import React from "react";

export const ZIndex = (props: React.PropsWithChildren<{
    zIndex: number
}>): JSX.Element =>
    <div style={{zIndex: props.zIndex}}>
        {props.children}
    </div>;
